import partner from './partnerEndpoints'
import wordpress from './wordpressEndpoints'

export default { partner, wordpress }
